import { z } from "zod";

export const emailSchema = z.string().trim().email({ message: "Please enter a valid email address" }).max(255, { message: "Email must be less than 255 characters" });

export const validateEmail = (email: string): { valid: boolean; message: string } => {
  const result = emailSchema.safeParse(email);
  if (result.success) return { valid: true, message: "" };
  return { valid: false, message: result.error.errors[0]?.message || "Please enter a valid email address" };
};
